import React from "react";
import {Form, Input, Upload} from "antd";

const advertiseFields = [
  {placeholder: 'Введите ссылку', name: 'order_url', label: 'Ссылка', type: 'text'},
  {placeholder: 'Введите номер слайда', name: 'priority', label: 'Номер слайда', type: 'number'},
]

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 10 },
};

export const AdvertisingForm = ({form, createAdvertisingSlide, advertisingFile, setAdvertisingFile}) => {
  return (
    <>
      <Form id="createCurator" form={form} onFinish={createAdvertisingSlide}>
        {advertiseFields.map( ({placeholder, label, name, type }) => (
          <Form.Item
            key={name}
            {...formItemLayout}
            label={label}
            name={name}
            rules={[{ required: true, message: `Пожалуйста, ${placeholder.toLowerCase()}` }]}
          >
            <Input placeholder={placeholder} type={type}/>
          </Form.Item>
        ))}
      </Form>
      <Upload
        beforeUpload={() => false}
        listType="picture-card"
        fileList={advertisingFile}
        onChange={(info) => setAdvertisingFile([...info.fileList])}
        showUploadList={{showPreviewIcon: false}}
      >
        {advertisingFile.length < 1 && 'Загрузить слайд'}
      </Upload>
    </>
  )
}
